/**
 * Responsável por "traduzir o datepicker" pra linguagem padrão do usuário
 *
 * @author: Adalto Junior <adaltojunior@sagaranatech.com> Date: 02/01/2013 Time:
 *          15:34
 */


Greenmile.Datepicker = Greenmile.Datepicker || {};

Greenmile.Datepicker.LocationFormat = function () {

    var dataFromDatePicker = {};

    this.getValuesToArray = function () {

        var minDays = [
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.sun"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.mon"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.tue"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.wed"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.thu"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.fri"),
            Monet.I18n.getResourcesByKey("Greenmile.Data.WeekDays.sat")
        ];

        var months = [
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.january'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.february'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.march'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.april'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.may'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.june'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.july'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.august'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.september'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.october'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.november'),
            Monet.I18n.getResourcesByKey('Greenmile.Data.Months.december')
        ];

        let defaultDate = "";
        if (Monet.I18n.locale.language === 'th'){
            defaultDate = "+543y";
        }

        dataFromDatePicker = {
            minDaysWeek: minDays,
            monthsName: months,
            defaultDate: defaultDate,
        };

    };

    this.setDataToDatepicker = function () {

        $.datepicker.regional['greenmile'] = {
            monthNames: dataFromDatePicker.monthsName,
            dayNamesMin: dataFromDatePicker.minDaysWeek,
            defaultDate: dataFromDatePicker.defaultDate,
        };

    };

    this.setDatePickerLocationDefault = function () {
        $.datepicker.setDefaults($.datepicker.regional['greenmile']);
    };

    this.unsetDatePickerLocationDefault = function () {
        $.datepicker.setDefaults($.datepicker.regional['']);
    };

    var init = function (self) {

        self.getValuesToArray();
        self.setDataToDatepicker();
        self.setDatePickerLocationDefault();

        // fix date for the current day when using thai locale
        $.datepicker._gotoToday = function () {
            $.datepicker._setDate($.datepicker._curInst, Monet.Format.Date.getLocaleToday());
            $.datepicker._setTime($.datepicker._curInst, Monet.Format.Date.getLocaleToday());
        };

    };

    init(this);

};
